function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import ViewportObserver from './ViewportObserver';

var WpTimelineBlock = /*#__PURE__*/function () {
  function WpTimelineBlock() {
    _classCallCheck(this, WpTimelineBlock);

    this.selBase = 'wp-block-acf-timeline';
    this.blocks = Array.from(document.querySelectorAll(".".concat(this.selBase)));
    this.items = Array.from(document.querySelectorAll(".".concat(this.selBase, "__item")));
    if (!this.blocks || this.blocks.length === 0) return;
    this.hideItems();
    this.bindObserver();
  }

  _createClass(WpTimelineBlock, [{
    key: "hideItems",
    value: function hideItems() {
      var _this = this;

      this.items.forEach(function (x) {
        return x.classList.add("".concat(_this.selBase, "__item--hidden"));
      });
    }
  }, {
    key: "bindObserver",
    value: function bindObserver() {
      var observer = new ViewportObserver(".".concat(this.selBase, "__item"), {
        threshold: '25%',
        onEnter: this.handleEnter.bind(this),
        onExit: false
      });
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(entry, observer) {
      entry.target.classList.remove("".concat(this.selBase, "__item--hidden"));
      entry.target.classList.add("".concat(this.selBase, "__item--visible"));
    }
  }]);

  return WpTimelineBlock;
}();

export { WpTimelineBlock as default };